import React from 'react';
import { useAuth } from '../context/AuthContext';
import './Admin.css';

const AdminCrossConnects = () => {
  const { user } = useAuth();

  const exampleCrossConnects = [
    {
      id: 1,
      customerName: user?.fullName || user?.username || 'You',
      contactEmail: user?.email || 'you@example.com',
      location: 'Cage 42, Cabinet A',
      suiteA: 'Suite 533',
      pointA: 'MDF Panel A1, Port 3',
      suiteZ: 'Suite 400',
      pointZ: 'Cage 42, Cabinet A, Port 1',
      type: 'Single-mode fiber',
      status: 'Active',
      requestedDate: '2025-01-20',
      isYou: true
    },
    {
      id: 2,
      customerName: 'Acme Corp',
      contactEmail: 'noc@acme.example.com',
      location: 'Cage 12, Cabinet B',
      suiteA: 'Suite 210',
      pointA: 'IDF 2, Patch panel 4',
      suiteZ: 'Suite 115',
      pointZ: 'Cage 12, Cabinet B, Port 2',
      type: 'Cat6 copper',
      status: 'Pending',
      requestedDate: '2025-02-03',
      isYou: false
    },
    {
      id: 3,
      customerName: 'TechStart LLC',
      contactEmail: 'infra@techstart.example.com',
      location: 'Cage 88, Cabinet C',
      suiteA: 'Suite 700',
      pointA: 'MDF Panel B2, Port 7',
      suiteZ: 'Suite 301',
      pointZ: 'Cage 88, Cabinet C, Port 1',
      type: 'Single-mode fiber',
      status: 'Scheduled',
      requestedDate: '2025-02-06',
      isYou: false
    }
  ];

  const statusClass = (status) => {
    const s = (status || '').toLowerCase();
    if (s === 'active') return 'admin-sub-active';
    if (s === 'pending' || s === 'scheduled') return 'admin-sub-pastdue';
    return 'admin-sub-none';
  };

  return (
    <div className="admin-card">
      <h1 className="admin-title">Cross Connects</h1>
      <p className="admin-subtitle">Cross connect requests and management — example view</p>

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Contact email</th>
              <th>Location</th>
              <th>Suite A</th>
              <th>Point A</th>
              <th>Suite Z</th>
              <th>Point Z</th>
              <th>Type</th>
              <th>Status</th>
              <th>Requested</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {exampleCrossConnects.map((row) => (
              <tr key={row.id}>
                <td>
                  {row.customerName}
                  {row.isYou && <span className="admin-cell-you"> (you)</span>}
                </td>
                <td>{row.contactEmail}</td>
                <td className="admin-cell-product">{row.location}</td>
                <td>{row.suiteA}</td>
                <td className="admin-cell-product">{row.pointA}</td>
                <td>{row.suiteZ}</td>
                <td className="admin-cell-product">{row.pointZ}</td>
                <td>{row.type}</td>
                <td>
                  <span className={`admin-sub-badge ${statusClass(row.status)}`}>
                    {row.status}
                  </span>
                </td>
                <td className="admin-cell-date">{row.requestedDate}</td>
                <td>
                  <button type="button" className="admin-btn admin-btn-role" disabled>
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCrossConnects;
